import React, { useState } from "react";
import { useTechnicianModel } from "../../technicianModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import useNavModel, { RouterParamType } from "@/model/navModel";


export function PageHeader() {
    const {
        searchDetParam,
        updateSearchDetParam,
        resetSearchDetParam,
        loadDetData
    } = useTechnicianModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Statistic Analysis"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Technician Performance"]}</span>
        {/* <span style={{ color: "#7F7F7F" }}>{"统计分析"} </span>
        <span style={{ color: "#000" }}>/ {"出入汇总表"}</span> */}
    </>
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    let { parentInfo } = detailsInfo

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "单据编号",
            placeholder: Locale["Document No."],
            fieldName: "tradeCode",
            size: "small",
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            placeholder: [Locale["CreationStartTime"], Locale["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
    ]
    return (
        <YhPageHeader
            // title="供应商管理"
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchDetParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchDetParam}
            handleSearch={loadDetData}
            handleReset={() => resetSearchDetParam(parentInfo)}
        />
    );
}